import React from "react";
import { useTranslation } from "react-i18next";
import CommonBtn from "../CommonBtn";
import CommonSimpleModal from "../CommonSimpleModal";
import Text from "../CommonCustomTxt";
import { View } from "react-native";
import {widthPercentageToDP as PR} from '../../styles/PixelRatio';

interface OwnProps {
  onClose: () => void;
  onConfirm: () => void;
}

const CommonDeleteEventModal = ({ onClose, onConfirm }: OwnProps) => {
  const { t } = useTranslation();

  return (
    <CommonSimpleModal
      title={t("translation:onboarding.neurologist.not_share_data_confirm.title")}
      alignTitle="center"
      titleWidth="95%"
      onClose={onClose}
    >
      <View
        style={{
          width: "90%",
          alignSelf: "center",
          marginTop: PR(10),
          marginBottom: PR(10),
        }}
      >
        <Text style={{ fontSize: PR(16), textAlign: "center" }}>
          {t("translation:onboarding.neurologist.not_share_data_confirm.body")}
        </Text>
      </View>
      <View style={{marginBottom: PR(5)}}>
        <CommonBtn
          click={onClose}
          title={t("translation:modal.btn.cancel")}
          type="tertiary"
        />
      </View>
      <CommonBtn
        click={onConfirm}
        title={t("translation:modal.btn.confirm")}
        type="primary"
      />
    </CommonSimpleModal>
  );
};

export default CommonDeleteEventModal;
